import { toString } from "lodash";

export const compareBasic = <T>(a: T, b: T): number => {
  if (a === b) {
    return 0;
  }

  return a > b ? 1 : -1;
};

export const compareText = <T>(a: T, b: T): number => {
  return compareBasic(toString(a).toLowerCase(), toString(b).toLowerCase());
};
